<template>
    <div class="org_list" v-if="organizations.length > 0">
        <div class="frame-wrap">
            <div class="btn-group btn-group-toggle" data-toggle="buttons" v-if="!is_select">

                <label class="btn  waves-effect waves-themed " :class="get_org_class(org)" v-on:click="set_active(org)" v-for="org in draw_organizations">
                    <input type="checkbox" name="options" id="check1" checked="checked">
                    {{org.title }}<span class="badge badge-icon pos-top pos-right mt-1 mr-1">{{org.attached_products_clean_count}}</span>
                </label>
            </div>

            <div class="" v-else>
                <v-select
                    class="org_filter_select"
                    v-model="active_org_obj"
                    @input="set_active"
                    :options=draw_organizations
                    label=title
                    :clearable="false"
                    :searchable=true
                >

                    <template v-slot:option="option">
                        <div class="pt-2 pb-2 ">
                            <div class='icon-stack fs-xl mr-3 position-relative'>
                                <i class="base base-19 icon-stack-3x opacity-100 color-primary-500"></i>
                                <i class="base base-2 icon-stack-2x opacity-100 color-primary-300"></i>
                                <i class="fas fa-arrow-right icon-stack-1x opacity-100 color-white"></i>
                                <span class="badge badge-icon pos-top pos-right mt-1 mr-1">{{option.attached_products_clean_count}}</span>
                            </div>

                            <span class="imc_opt ">
                                {{option.title }}
                             </span>
                        </div>

                    </template>


                </v-select>
            </div>

        </div>
    </div>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';
import vSelect from 'vue-select'
const {mapFields} = createHelpers({
    getterType: 'inbox_state/getInboxStateField',
    mutationType: 'inbox_state/updateInboxStateField',
});
import {mapGetters} from "vuex";

export default {
    name: "organization_filter",
    components : {
        vSelect
    },
    data() {
        return {
            organizations: [],
            is_load: true,
        }
    },
    created() {
        this.load_filter_organiztions();
    },
    methods : {

        get_org_class(org) {
            if(org.is_active) {
                return "btn-primary active";
            }

            return  "btn-outline-primary";
        },

        set_active(org) {
            EventBus.$emit('filter_select_change', {
                "type": "org_id",
                "value": org.id
            });

            EventBus.$emit('choose_org_id', {
                "type": "org_id",
                "value": org.id
            });
        },

        async load_filter_organiztions() {
            this.organizations = [];
            this.is_load = true;

            await api.get('/internal/v1/catalog/organizations/with/products_count').then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.organizations = data.data;
                    this.organizations.map(item => {
                        item.is_active = false;
                    })
                } else {
                    this.organizations = [];
                }
            }).catch(({response}) => {
                this.is_load = false;
                this.organizations = [];
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        }
    },
    computed : {

        is_select() {
            return this.draw_organizations.length > 5;
        },

        draw_organizations () {
            return this.organizations.map(org => {
                org.is_active = parseInt(org.id) === this.active_org;
                return org;
            });
        },

        active_org () {
            try {
                return parseInt(this.all_filter.org_id);
            }
            catch (e) {

            }
            return 0;
        },

        active_org_obj : {
             get :function () {
                let active = null;
                this.draw_organizations.map(item => {
                    if(item.is_active) {
                        active = item;
                    }
                })

                return active;
            },
            set : function(val) {

            }
        },

        ...mapFields([
            'list',
            'filter',
            'doc_type',
            'send_list',
            'all_filter'
        ]),
    }
}
</script>

<style scoped>

</style>
